import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ActionIcon, Card, Grid, Group, Image, Text, Title } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';

//import BarChart from '../BarChart';
//import TeamImage from "../TeamImage";
import DataCard from '../DataCard';
import NotesCard from '../NotesCard';
import TeamNotesCard from '../TeamNotesCard';
//import EndgameCard from '../EndGameCard';
//import RatingCard from '../RatingCard';
import SummaryCard from '../SummaryCard';


const Team = (props) => {
  const { number } = useParams();
  const [loading, setLoading] = useState(false);
  const [nick, setNick] = useState();
  const [stats, setStats] = useState();
  const [matches, setMatches] = useState();
  const [teamNotes, setTeamNotes] = useState();
  const [photoIndex, setPhotoIndex] = useState(0);

  useEffect(() => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 1000);

  }, [number, props.event]);

  useEffect(() => {
    setPhotoIndex(0);
  }, [number, props.event]);

  useEffect(() => {
    setStats(undefined);
    setMatches(undefined);
    setTeamNotes(undefined);

    const getTeam = async () => {
      try {
        const response = await fetch(`https://server.palyrobotics.com/team/${props.event}/${number}`);
        const data = await response.text();
        const team = JSON.parse(data);

        setNick(team.name);
        setStats({
          "avg": team.average,
          "max": team.max,
          "min": team.min,
          "total": team.total,
          "percent": team.percent
        });
        console.log("Team data:", team);
        console.log("Matches:", team.qm);
        setMatches(team.qm);
        setTeamNotes(team.notes);
      } catch (error) {
        console.error("Error fetching team data:", error);
      }
    }

    if (!loading) {
      getTeam();
    }
  }, [loading, number, props.event]);

  if (loading) {
    return (
      <div className="container">Loading...</div>
    );
  }

  const photos = Array.isArray(teamNotes?.photos) ? teamNotes.photos : [];
  const currentPhotoIndex = photos.length ? photoIndex % photos.length : 0;
  const currentPhoto = photos[currentPhotoIndex];

  return (
    <Grid>
        <Grid.Col span={12}>
          <Title order={2}>Team {number}</Title>
        </Grid.Col>
        {currentPhoto && (
          <Grid.Col span={12}>
            <Card withBorder>
              <Group position="apart" mb="sm">
                <Text weight={600}>Robot Photos</Text>
                <Text size="sm" color="dimmed">{currentPhotoIndex + 1} / {photos.length}</Text>
              </Group>
              <Group position="center" noWrap spacing="sm">
                <ActionIcon
                  aria-label="Previous photo"
                  title="Previous photo"
                  size="lg"
                  variant="light"
                  onClick={() => setPhotoIndex((index) => (index - 1 + photos.length) % photos.length)}
                  disabled={photos.length < 2}
                >
                  <IconChevronLeft size={20} />
                </ActionIcon>
                <Image
                  src={currentPhoto.url}
                  alt={currentPhoto.name || `Team ${number} robot photo ${currentPhotoIndex + 1}`}
                  caption={currentPhoto.name}
                  fit="contain"
                  height={420}
                  style={{ flex: 1, maxWidth: 900 }}
                />
                <ActionIcon
                  aria-label="Next photo"
                  title="Next photo"
                  size="lg"
                  variant="light"
                  onClick={() => setPhotoIndex((index) => (index + 1) % photos.length)}
                  disabled={photos.length < 2}
                >
                  <IconChevronRight size={20} />
                </ActionIcon>
              </Group>
            </Card>
          </Grid.Col>
        )}
        <Grid.Col span={12}>
            <DataCard team={number} stats={stats} matches={matches}/>
        </Grid.Col>

        <Grid.Col span={12}>
          <TeamNotesCard
            event={props.event}
            team={number}
            notes={teamNotes}
            onSaved={setTeamNotes}
          />
        </Grid.Col>

        

      {/* row four */}
      <Grid.Col span={12}>
        <Card>
          <NotesCard matches={matches}/>
        </Card>
      </Grid.Col>


    </Grid>
  );
}

export default Team;